import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ lineParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `line/getSearched`,
      params: lineParams,
    });
    const allLine = data;
    yield put(Actions.setAll({ allLine }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchLine({ lineId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `line/${lineId}`,
    });
    const line = data.toJS();
    yield put(Actions.setLine({ line }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
function* getAll() {
  try {
    const { data } = yield call(api.get, {
      route: 'line',
    });
    const allLine = data;
    yield put(Actions.setAll({ allLine }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
function* fetchAllFactoryLines({ factoryId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    const { data } = yield call(api.get, {
      route: `line/getlinesbyfactory/` + factoryId,
    });

    const factoryLines = data;
    yield put(Actions.setAllFactoryLines({ factoryLines }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateLines({ lineData, actionName, lineParams, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `line`,
      data: lineData,
    });
    if (callback) callback();
    yield put(Actions.fetchAll({ lineParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD ? CONSTANT_VARIABLES.LINE_CREATED : CONSTANT_VARIABLES.LINE_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteLine({ id, lineParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `line/${id}`,
    });
    yield put(Actions.fetchAll({ lineParams }));
    notification('success', CONSTANT_VARIABLES.LINE_DELETED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchLineDetailOEE({ lineId, factoryId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    const { data } = yield call(api.get, {
      route: `Dashboards/linedetailoee/${factoryId}/${lineId}`,
    });

    const lineDetailOEE = data.toJS();
    yield put(Actions.setLineDetailOEE({ lineDetailOEE }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchLineTrend({ trendRequestModel }) {
  try {
    const { equipId } = trendRequestModel;
    yield put(Actions.setLoader({ showLoader: true }));

    const { data } = yield call(api.post, {
      route: `Telemetry/linetrends/${equipId}`,
      data: trendRequestModel,
    });

    var lineTrend = data.toJS();

    yield put(Actions.setLineTrend({ lineTrend }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchLineVisionEquipments({ lineId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    const { data } = yield call(api.get, {
      route: `Line/${lineId}/visionEquipments`,
    });

    var visionEquipments = data.toJS();

    yield put(Actions.setLineVisionEquipments({ visionEquipments }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.GET_ALL, getAll),
    takeLatest(ActionTypes.FETCH_LINE, fetchLine),
    takeLatest(ActionTypes.FETCH_ALL_BY_FACTORY_ID, fetchAllFactoryLines),
    takeLatest(ActionTypes.ADD_OR_UPDATE_LINE, addorUpdateLines),
    takeLatest(ActionTypes.DELETE_LINE, deleteLine),
    takeLatest(ActionTypes.FETCH_LINE_DETAIL_OEE, fetchLineDetailOEE),
    takeLatest(ActionTypes.FETCH_LINE_TREND, fetchLineTrend),
    takeLatest(ActionTypes.FETCH_LINE_VISION_EQUIPMENTS, fetchLineVisionEquipments),
  ]);
}
